/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Poly7IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Poly7Icon(props: Poly7IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 100 104"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        stroke={"currentColor"}
        strokeLinejoin={"round"}
        strokeWidth={"2"}
        d={"m17.865 1 56.432 11.714L98.946 53l-17.514 50-57.405-14.286L1 53z"}
      ></path>
    </svg>
  );
}

export default Poly7Icon;
/* prettier-ignore-end */
